// extracted by mini-css-extract-plugin
export default {"root":"root--FZOxk","main":"main--kUZd5","side":"side--bBjFB","withSeparator":"withSeparator--UV3jB"};